import React, { useState, useEffect } from "react";
import { Modal, Typography, Button, Form, Input } from "antd";
import * as breakActions from "../../../../redux/actions/break.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const {Text}=Typography;
const BreakModal = (props) => {
  const [MBtnLoading, setMBtnLoading] = useState(false);
  const [valueBrakeval, setValueBrakeval] = useState(null);

  useEffect(() => {
    if(props.visible === true){
      const dataTid = {
        riderId: props.postData,
        type: "free",
      };
      setValueBrakeval(dataTid)
    }
  }, [props.visible]);

  const statusSubmit = async (values) => {
    try {
      setMBtnLoading(true);
      await props.breakActions.breakMarkAction(values);
    } catch (e) {} finally {
      setMBtnLoading(false);
      props.postDataRefresh();
      props.setvisible(false);
    }
  };
  const handleCancel = () => {props.setvisible(false)};

  useEffect(() => {
    if (valueBrakeval) {
      form.setFieldsValue(valueBrakeval);
    }
  }, [valueBrakeval]);
  const [form] = Form.useForm();
  return (
    <Form
      id="myForm"
      form={form}
      layout="vertical"
      initialValues={valueBrakeval}
      onFinish={statusSubmit}
    >
        <Modal
          title="End break"
          visible={props.visible}
          onCancel={handleCancel}
          footer={[
            <Button loading={MBtnLoading} onClick={handleCancel}>Cancel</Button>,
            <Button loading={MBtnLoading} form="myForm" key="submit" htmlType="submit">End break</Button>,
          ]}
        >
          <Text>Are you sure you want to end break?</Text>
          <Form.Item hidden name={"type"}><Input /></Form.Item>
          <Form.Item hidden name={"riderId"}><Input /></Form.Item>
          {/* <Form.Item
            name={"duration"}
            label="Duration"
            rules={[{ required: true, message: "Duration is Required" }]}
          >
            <Select
              placeholder="Duration"
              style={{ width: "100%" }}
              value={filter}
              onChange={setFiltervalue}
            >
              {plainOptionsTime &&
                plainOptionsTime.map((item) => (
                  <Option value={item.value}>{item.label}</Option>
                ))}
            </Select>
          </Form.Item>
          {filter == "customize" ? (
            <Form.Item
              name={"startDate"}
              label="Start Date"
              rules={[
                {
                  required: true,
                  message: "Please add start date time",
                },
              ]}
            >
              <DatePicker
                format="YYYY-MM-DD HH:mm:ss"
                disabledDate={disabledDate}
                showTime={{
                  defaultValue: moment("00:00:00", "HH:mm:ss"),
                }}
                style={{ width: "100%" }}
              />
            </Form.Item>
          ) : (
            ""
          )}
          {filter == "customize" ? (
            <Form.Item
              name={"endDate"}
              label="End Date"
              rules={[
                {
                  required: true,
                  message: "Please add end date time",
                },
              ]}
            >
              <DatePicker
                format="YYYY-MM-DD HH:mm:ss"
                disabledDate={disabledDate}
                showTime={{
                  defaultValue: moment("00:00:00", "HH:mm:ss"),
                }}
                style={{ width: "100%" }}
              />
            </Form.Item>
          ) : (
            ""
          )}
          <Form.Item
            name={"reason"}
            label="Reason"
            rules={[{ required: true, message: "Reason is Required" }]}
          >
            <Select
              placeholder="Reason for Assigning"
            >
              {plainOptionsreason &&
                plainOptionsreason.map((item) => (
                  <Option value={item.value}>{item.label}</Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <Button loading={MBtnLoading} htmlType="submit">
              Submit Rider Brake
            </Button>
          </Form.Item> */}
      </Modal>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    taskListData: state.BreakReducer.taskData,
    storeIdsFilter: state.BreakReducer.taskFilter,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    breakActions: bindActionCreators(breakActions, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(BreakModal);